import React, { useState, useEffect } from 'react';
import ImsTable from './imstable';
import constant from '../../../constant';

const ImsContent = () => {
  const [ims, setIms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMonthYearFilter, setSelectedMonthYearFilter] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const formatDateForApi = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return `${year}-${month}`;
  };

  const constructApiUrl = (endpoint, monthFilter) => {
    const userRole = localStorage.getItem("role");
    const adminSelectedUser = localStorage.getItem("adminSelectedUser");
    let apiUrl = `${constant.REACT_APP_API_URL}${endpoint}`;

    const queryParams = [];

    if (userRole === "admin" && adminSelectedUser) {
      queryParams.push(`userId=${adminSelectedUser}`);
    }

    if (monthFilter) {
      queryParams.push(`month=${monthFilter}`);
    }

    if (queryParams.length > 0) {
      apiUrl += (endpoint.includes("?") ? "&" : "?") + queryParams.join("&");
    }

    return apiUrl;
  };

  useEffect(() => {
    const fetchIms = async () => {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');

      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        setIms([]);
        return;
      }

      try {
        const monthQueryParam = formatDateForApi(selectedMonthYearFilter);
        const apiUrl = constructApiUrl("/purchase/ims", monthQueryParam);

        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (response.ok) {
          setIms(result.data || []);
        } else {
          setError(result.message || 'Failed to fetch items');
          setIms([]);
        }
      } catch (err) {
        setError(`Error fetching items: ${err.message}`);
        setIms([]);
      } finally {
        setLoading(false);
      }
    };

    fetchIms();
  }, [selectedMonthYearFilter, refreshTrigger]);

  const handleMonthYearFilterChange = (date) => {
    setSelectedMonthYearFilter(date);
  };

  const handleDataRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="px-6 pt-16 md:pt-0 flex justify-center items-center h-screen">
        <div className="text-red-600 bg-red-100 border border-red-400 p-4 rounded-md shadow-md">
          <strong>Error:</strong> {error}
        </div>
      </div>
    );
  }

  return (
    <div className="px-6 pt-16 md:pt-0">
      <ImsTable
        ims={ims}
        onStatusChange={handleDataRefresh}
        currentMonthFilter={selectedMonthYearFilter}
        onMonthYearFilterChange={handleMonthYearFilterChange}
      />
    </div>
  );
};

export default ImsContent;